import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { LoanapprovallevelService } from "../shared/loanapprovallevel.service";

@Component({
  selector: 'app-loanapprovallevellist',
  templateUrl: './loanapprovallevellist.component.html',
  styleUrls: ['./loanapprovallevellist.component.css']
})
export class LoanapprovallevellistComponent implements OnInit {

  displayedColumns: string[] = ['Scheme Name', 'Loan Category', 'Loanapprovallevel', 'Min. Loan Amount', 'Max. Loan Amount', 'New'];
  ChequeList$ = [''];
  dataSource = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private router: Router, private loanapprovallevelService: LoanapprovallevelService) {
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit() {
    this.GetLoanApprovalLevelList();
  }

  GetLoanApprovalLevelList() {
    this.loanapprovallevelService.FetchLoanApprovalLevelList().subscribe(data => {
      this.dataSource.data = data;
    })
  }

  public AddNew() {
    this.router.navigate(['/loanapprovallevel']);
  }

  Edit(ledger: any) {
    this.router.navigate(['/loanapprovallevel', ledger.Id]);
  }

}